<template>
  <div
    id="advantages"
    :style="{ backgroundColor: country === 'hongkong' ? '#ffffff' : '' }"
  >
    <div class="inner">
      <div class="top">
        <div class="top_box">
          <div class="top_title">
            {{
              isUK
                ? $t("home_advantages_partner_title")
                : $t("home_advantages_title")
            }}
          </div>
        </div>
        <div class="top_tabs" v-if="!isUK">
          <div class="top_tabs_t">
            <div
              class="top_tabs_t_l"
              :class="
                activeTab == 0 ? 'top_tabs_t_active' : 'top_tabs_t_active2'
              "
              @click="tabClick(0)"
            >
              {{ $t("home_advantages_partner_tab") }}
            </div>
            <div
              class="top_tabs_t_r"
              :class="
                activeTab == 1 ? 'top_tabs_t_active' : 'top_tabs_t_active2'
              "
              @click="tabClick(1)"
            >
              {{ $t("home_advantages_agent_tab") }}
            </div>
          </div>
          <div class="top_content">
            <img
              class="top_content_l"
              :src="activeTab == 0 ? partnerImg : agentImg"
            />
            <div class="top_content_r">
              <div
                class="top_desc"
                :class="{ 'agent-desc': activeTab === 1 && !isUK }"
                v-for="(item, idx) in finalTopList[activeTab]"
                :key="idx"
                :style="{
                  height: isHKEn && activeTab === 0 ? '19vw' : '',
                  minHeight: isHKEn && activeTab === 0 ? '9vw' : '',
                  paddingTop: isHKEn ? '1vw' : '1.6vw',
                }"
              >
                <div class="top_content_title">{{ $t(item.title) }}</div>
                <div class="top_content_desc">
                  {{ $t(item.desc) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="top_content" v-if="isUK">
          <img class="top_content_l" :src="partnerImg" />
          <div class="top_content_r">
            <div
              class="top_desc"
              v-for="(item, idx) in finalTopList[0]"
              :key="idx"
            >
              <div class="top_content_title">{{ $t(item.title) }}</div>
              <div class="top_content_desc">{{ $t(item.desc) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "AdvantageView",
  data() {
    return {
      activeTab: 0,
      partnerImg: require("@/assets/Keeta2/partner@2x.png"),
      agentImg: require("@/assets/Keeta2/partner2@2x.png"),
    };
  },
  methods: {
    tabClick(tabIndex) {
      this.activeTab = tabIndex;
    },
  },
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    isUK() {
      return this.country === "uk";
    },
    isHKEn() {
      return this.country === "hongkong" && this.$i18n.locale === "en";
    },
    finalTopList() {
      // Partner
      const partnerList = this.isHKEn
        ? [
            {
              title: "home_advantages_partner_1_title_hk",
              desc: "home_advantages_partner_1_desc_hk",
            },
            {
              title: "home_advantages_partner_2_title_hk",
              desc: "home_advantages_partner_2_desc_hk",
            },
            {
              title: "home_advantages_partner_3_title_hk",
              desc: "home_advantages_partner_3_desc_hk",
            },
          ]
        : [
            {
              title: "home_advantages_partner_1_title",
              desc: "home_advantages_partner_1_desc",
            },
            {
              title: "home_advantages_partner_2_title",
              desc: "home_advantages_partner_2_desc",
            },
            {
              title: "home_advantages_partner_3_title",
              desc: "home_advantages_partner_3_desc",
            },
          ];
      // Agent
      const agentList = [
        {
          title: "home_advantages_agent_1_title",
          desc: "home_advantages_agent_1_desc",
        },
        {
          title: "home_advantages_agent_2_title",
          desc: "home_advantages_agent_2_desc",
        },
        {
          title: "home_advantages_agent_3_title",
          desc: "home_advantages_agent_3_desc",
        },
        {
          title: "home_advantages_agent_4_title",
          desc: "home_advantages_agent_4_desc",
        },
      ];
      return [partnerList, agentList];
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/_variables.scss";
#advantages {
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 120px 0;
  background-color: #f7f8f9;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    .top_box {
      width: 100%;
      min-width: 431px;
      .top_title {
        color: #000000;
        font-weight: 900;
        font-size: 1.3rem;
        margin-top: -32px;
        font-family: $title-font;
      }
    }

    .top_tabs {
      margin-top: 37px;
      width: 100%;
      .top_tabs_t {
        display: flex;
        text-align: center;
        font-weight: 600;
        font-size: $font-size-base;
        line-height: 46px;
        font-family: $content-font;
        .top_tabs_t_l {
          width: 50%;
          height: 100%;
        }
        .top_tabs_t_r {
          width: 50%;
          height: 100%;
        }
        .top_tabs_t_active {
          border-bottom: 2px #000000 solid;
        }
        .top_tabs_t_active2 {
          border-bottom: 1px #d8d8d8 solid;
        }
      }
    }
    .top_content {
      margin-top: 64.5px;
      width: 100%;
      height: 613px;
      display: flex;
      .top_content_l {
        height: 100%;
        margin-right: 60px;
      }
      .top_content_r {
        width: 752px;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .top_desc {
          height: 190px;
          min-height: 120px;
          // margin-bottom: 36.5px;
          border-radius: 20px;
          padding: 26px 20px 20px 30px;
          background: #ffffff;
          box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.08);
          font-family: $content-font;
          &.agent-desc {
            margin-bottom: 0;
          }
          .top_content_title {
            margin-bottom: 12px;
            font-weight: 700;
            font-size: $font-size-small;
          }
          .top_content_desc {
            font-weight: 400;
            font-size: $font-size-mini;
            color: #999999;
            line-height: 28px;
          }
        }
      }
    }
  }
}
</style>
